import { Schema } from "effect";
import { ChatAttachment, ChatConfigResponse, ChatThreadSummary, type ChatMessageRequest } from "@workerstation/shared/chat-contract";
import { ChatSessionState, emptyChatSession } from "@workerstation/shared/chat-session-model";
export const ChatThreadError = Schema.Struct({ threadId: Schema.String, message: Schema.String });
export const ChatSnapshot = Schema.Struct({
  stationId: Schema.NullOr(Schema.String), threadId: Schema.NullOr(Schema.String),
  config: Schema.NullOr(ChatConfigResponse), threads: Schema.Array(ChatThreadSummary),
  session: ChatSessionState, turnActive: Schema.Boolean, draft: Schema.String,
  error: Schema.NullOr(Schema.String), threadError: Schema.NullOr(ChatThreadError), tailError: Schema.NullOr(Schema.String),
  creating: Schema.Boolean, configuring: Schema.Boolean, stopping: Schema.Boolean,
  sendingThreads: Schema.Array(Schema.String), approving: Schema.Array(Schema.String), resolving: Schema.Array(Schema.String),
  closed: Schema.Boolean
});
export type ChatSnapshot = typeof ChatSnapshot.Type;
export const emptyChatSnapshot = (): ChatSnapshot => ({
  stationId: null, threadId: null, config: null, threads: [], session: emptyChatSession(), turnActive: false, draft: "",
  error: null, threadError: null, tailError: null, creating: false, configuring: false, stopping: false,
  sendingThreads: [], approving: [], resolving: [], closed: false
});
export const ChatConfigure = Schema.Struct({ model: Schema.optionalKey(Schema.String), yolo: Schema.optionalKey(Schema.Boolean) });
export const ChatCommand = Schema.Union([
  Schema.Struct({ _tag: Schema.Literal("Select"), threadId: Schema.NullOr(Schema.String) }),
  Schema.Struct({ _tag: Schema.Literal("Draft"), threadId: Schema.String, text: Schema.String }),
  Schema.Struct({ _tag: Schema.Literal("Create") }),
  Schema.Struct({ _tag: Schema.Literal("AttachmentError"), threadId: Schema.NullOr(Schema.String), message: Schema.String }),
  Schema.Struct({ _tag: Schema.Literal("Configure"), patch: ChatConfigure }),
  Schema.Struct({ _tag: Schema.Literal("Stop"), threadId: Schema.String }),
  Schema.Struct({ _tag: Schema.Literal("Approval"), threadId: Schema.String, approvalId: Schema.String, approve: Schema.Boolean }),
  Schema.Struct({ _tag: Schema.Literal("Proposal"), threadId: Schema.String, proposalId: Schema.String, action: Schema.Literals(["merge", "discard"]) })
]);
export type ChatCommand = typeof ChatCommand.Type;
export const ChatAction = Schema.Struct({ stationId: Schema.String, command: ChatCommand });
export type ChatAction = typeof ChatAction.Type;
export const ChatSubmission = Schema.Struct({ stationId: Schema.String, threadId: Schema.String, text: Schema.String, attachments: Schema.Array(ChatAttachment) });
export type ChatSubmission = typeof ChatSubmission.Type;
export interface ChatSettlement {
  readonly id: number;
  readonly kind: "create" | "configure" | "send" | "stop" | "approval" | "proposal";
  readonly stationId: string;
  readonly threadId: string | null;
  readonly resourceId: string | null;
  readonly outcome: "success" | "failure";
  readonly message: string | null;
  readonly presented: boolean;
}
export const chatResourceKey = (...parts: readonly (string | number | null)[]): string => JSON.stringify(parts);
export type ChatMessagePayload = ChatMessageRequest;
